<template>
    <div>
        <div id="worksends-page-header" class="tw-grid tw-mt-2 tw-grid-cols-2">
            <div>
                <div class="breadcrumbs" id="breadcrumbs">
                    <router-link class="breadcrumb-link" to="/fulfilment/">Fulfilment</router-link>  &gt;
                    <router-link class="breadcrumb-link" to="/fulfilment/">Your Shop Orders</router-link>
                </div>
                <h3>Your Shop Orders</h3>
                <div class="ws-filter-links" v-if="!showFeesColumns">
                    <div class="ws-filter-link" :class="'status-all '+(pageParams.filters.status.val?'':'active')">
                        <router-link to="/fulfilment/" event @click.native.prevent="setFilter('status',null)">All Orders</router-link>
                        ({{ allOrdersCount }})
                    </div>
                    <div class="ws-filter-link" v-for="status in index.meta.statuses" :class="'status-'+status.status+' '+(pageParams.filters.status.val==status.status?'active':'')">
                        <router-link :to="'/fulfilment?status='+status.status" event @click.native.prevent="setFilter('status',status.status)">{{ statusName(status.status) }}</router-link>
                        ({{ status.total }})
                    </div>
                </div>
            </div>
            <div class="ws-filters tw-flex tw-justify-end" :style="showFeesColumns?'margin-top: 6px':'margin-top: 27px'">
                <div class="ws-filter ws-filter-search" style="min-width: 250px">
                    <span class="fulfilment-action-button ws-button" @click="openImportWHOrdersModal">Import Orders</span>
                    <span class="fulfilment-action-button ws-button ws-button-secondary" @click="modals.fulfilmentExportModal = true">Export CSV</span>
                </div>

                <div class="ws-filter ws-filter-select" v-if="showFeesColumns">
                    <label>Order Status</label>
                    <select v-model="pageParams.filters.status.val" @change="setFilter(null)" >
                        <option value="null">All Order Statuses</option>
                        <option v-for="status in selectFilterOrderStatuses" :value="status" >{{ statusName(status) }} ({{ getStatusCount(status) }})</option>
                    </select>
                </div>

                <div class="ws-filter ws-filter-date">
                    <label>Date range start</label>
                    <input type="date" v-model="pageParams.filters.date_start.val" @change="setFilter(null)" placeholder="Made after..." min="2020-01-01" :max="maxDate" :class="pageParams.filters.date_start.val?'has-value':'no-value'">
                </div>

                <div class="ws-filter ws-filter-date">
                    <label>Date range end</label>
                    <input type="date" v-model="pageParams.filters.date_end.val" @change="setFilter(null)" placeholder="Made before..." :min="pageParams.filters.date_start.val?pageParams.filters.date_start.val:'2020-01-01'" :max="maxDate" :class="pageParams.filters.date_end.val?'has-value':'no-value'">
                </div>

                <div class="ws-filter ws-filter-search">
                    <label>Search orders</label>
                    <input type="text" v-model="pageParams.search.val" @keyup="setFilter(null)" placeholder="Search...">
                </div>
            </div>
        </div>
        
        <div class="worksends-scrollable-table-wrap" style="margin-bottom: 50px">
            <table id="list-of-warehouse-orders"  class="worksends-table worksends-table-fulfilment">
                <thead>
                <tr>
                    <th class="field-select"></th>
                    <th class="field-id"><div class="sortable" :class="sortClass('warehouse_id', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('warehouse_id')">Order ID</div></th>
                    <th class="field-original-id"><div class="sortable" :class="sortClass('original_id', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('original_id')">Original ID</div></th>

                    <th class="field-order-status"><div class="sortable" :class="sortClass('status', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('status')">Status</div></th>
                    <th class="field-customer"><div class="sortable" :class="sortClass('customer_name', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('customer_name')">Customer</div></th>
                    <th class="field-destination">Destination</th>

                    <th v-if="showFeesColumns" class="field-fee">Status Updates</th>
                    <th v-if="showFeesColumns" class="field-fee">WH Requests</th>
                    
                    <th class="field-content">Content</th>
                    <th class="field-order-date"><div class="sortable" :class="sortClass('order_date', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('order_date')">Ordered At</div></th>
                    <th class="field-sent-date"><div class="sortable" :class="sortClass('send_date', pageParams.pageOptions.sortyBy, pageParams.pageOptions.sortDesc)" @click="sortBy('order_date')">Sent At</div></th>
                    <th class="field-delivered-date">Delivered At</th>
                    <th class="field-tracking">Carrier & Method</th>
                    <th v-if="showFeesColumns" class="field-fee">Handling Fee</th>
                    <th v-if="showFeesColumns" class="field-fee">Freight Fee</th>
                    <th v-if="showFeesColumns" class="field-fee">IOSS VAT Fee</th>
                    <th class="field-actions">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in index.data" :class="item.selected?'selected':''">
                    <td class="field-select">
                        <div class="row-select-box" @click="selectRow(item)"></div>
                    </td>
                    <td class="field-id" data-label="Order ID">
                        <b><a :href="'#'">#{{ item.warehouse_id }}</a></b>
                    </td>
                    <td class="field-original-id" data-label="Original ID">
                        <b><a :href="'#'">#{{ item.original_id }}</a></b>
                    </td>
                    <td class="field-order-status" data-label="Order Status">
                        <div :class="'status status-'+item.status">{{ item.status }}</div>
                    </td>

                    <td class="field-customer" data-label="Customer">
                        <div class="customer-name"><b>{{ item.customer_name }}</b></div>
                        <a class="customer-email" :href="'mailto:'+item.customer_email" style="display: block; margin-top: -3px">{{ item.customer_email }}</a>
                    </td>
                    <td class="field-destination" data-label="Destination">
                        {{ item.destination }}
                    </td>

                    <td v-if="showFeesColumns" class="field-fee" data-label="Status Updates">
                        <div v-for="(update, updateIndex) in item.status_updates" class="status-update">
                            <div v-if="updateIndex === 0 || expandedUpdates[item.id]===true" style="min-width: 200px; margin: 5px 0;">
                                <div class="status-update-reason">{{ update.reason }}</div>
                                <i class="status-update-date">{{ update.updated_at | moment("DD/MM HH:mm") }}</i>
                            </div>
                            <div class="status-update-extras ws-button ws-button-secondary small" @click="toggleUpdates(item.id)" v-if="item.status_updates.length > 1 && updateIndex===0">+{{ item.status_updates.length - 1}}</div>
                        </div>
                    </td>

                    <td v-if="showFeesColumns" class="field-fee" data-label="WH Requests">
                        <div v-for="(request, requestIndex) in item.warehouse_requests" class="status-update">
                            <div v-if="requestIndex === 0 || expandedRequests[item.id]===true" style="min-width: 200px; margin: 5px 0;">
                                <div class="status-update-reason"><b>{{ request.subject }}:</b> {{ request.message }}</div>
                                <i class="status-update-date">{{ request.updated_at | moment("DD/MM HH:mm") }}</i>
                            </div>
                            <div class="status-update-extras ws-button ws-button-secondary small" @click="toggleRequests(item.id)" v-if="item.warehouse_requests.length > 1 && requestIndex===0">+{{ item.warehouse_requests.length - 1}}</div>
                        </div>
                    </td>
                    
                    
                    <td class="field-content" data-label="Content">
                        <div class="package-content">
                            <div class="package-item" v-for="line in item.line_items.slice(0,3)" :style="line.item_image?'background-image: url('+line.item_image+')':''" v-tooltip="tooltip(line)">
                            </div>
                        </div>
                    </td>
                    <td class="field-order-date two-row-date" data-label="Ordered At">
                        <div class="date">{{ item.order_date | moment("DD/MM") }}</div>
                        <div class="time">{{ item.order_date | moment("HH:mm") }}</div>
                    </td>
                    <td class="field-sent-date two-row-date" data-label="Sent At">
                        <div class="date">{{ item.send_date | moment("DD/MM") }}</div>
                        <div class="time">{{ item.send_date | moment("HH:mm") }}</div>
                    </td>
                    <td class="field-delivered-date two-row-date" data-label="Delivered At">
                        <div class="date">{{ item.expected_delivery | moment("DD/MM") }}</div>
                        <div class="time">{{ item.expected_delivery | moment("HH:mm") }}</div>
                    </td>
                    <td class="field-tracking" data-label="Carrier & Method">
                        <div class="carrier" v-if="item.carrier"><b>{{ item.carrier }}</b> {{ item.carrier_method }}</div>
                        <a class="tracking-link" v-if="item.carrier_url" :href="item.carrier_url" target="_blank" style="font-size: 11px; margin-top: -3px; display: block;">TRACKING INFO →</a>
                    </td>
    
                    <td v-if="showFeesColumns" class="field-fee" data-label="Handling Fee">
                        <div v-if="item.transaction_id" class="fee">{{ item.handling_fee??0 | toCurrency }}</div>
                    </td>
    
                    <td v-if="showFeesColumns" class="field-fee" data-label="Freight Fee">
                        <div v-if="item.transaction_id" class="fee">{{ item.freight_fee??0 | toCurrency }}</div>
                    </td>
    
                    <td v-if="showFeesColumns" class="field-fee" data-label="IOSS VAT Fee">
                        <div v-if="item.transaction_id" class="fee">{{ item.ioss_vat_fee??0 | toCurrency }}</div>
                    </td>

                    <td class="field-actions" data-label="Actions">
                        <div class="ws-button small" @click="openWarehouseRequestModal(item)">WH Request</div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div ref="loadMore" v-show="!lazyLoading" v-if="index.meta.current_page < index.meta.last_page" class="ws-button ws-button-secondary small load-more-button" @click="loadMore">Load More...</div>
        <div class="loadable load-more-loader" v-show="lazyLoading"><div class="value-loader"></div></div>
        
        <div class="multi-action" v-if="selectedOrdersCount">
            <div class="multi-action-summary">
                You have <b>{{ selectedOrdersCount }}</b> out of <b>{{ index.meta.total }}</b> orders selected.
                <div class="ws-button ws-button-secondary tiny" style="margin-left: 7px"  @click="selectAll">Select All</div>
            </div>
            <div class="multi-action-action">With selected: 
                <div class="ws-button small" @click="openWarehouseRequestModal(null)">Warehouse Request</div>
                <div class="ws-button small ws-button-negative" @click="cancelOrders">Delete Orders</div>
            </div>
        </div>

        <warehouse-request-modal type="orders" :items="requestItems" v-if="modals.whRequestModal" @sent="getPage" />
        <import-wh-orders-modal v-if="modals.importWHOrdersModal" @imported="getPage" />
        <fulfilment-export-modal v-if="modals.fulfilmentExportModal" :last-id="index.data[0].warehouse_id" ></fulfilment-export-modal>


    </div>
</template>

<script>
import moment from "moment";
import debounce from 'lodash/debounce';
import {isInViewport} from "@/utils/mixins";
import WarehouseRequestModal from "@/components/modals/WarehouseRequestModal.vue";
import ImportWhOrdersModal from "@/components/modals/ImportWhOrdersModal.vue";
import FulfilmentExportModal from "@/pages/fulfilment/FulfilmentExportModal.vue";

export default {
    name: "FulfilmentIndex",
    components: {FulfilmentExportModal, WarehouseRequestModal, ImportWhOrdersModal},
    data: () => ({
        lazyLoading: false,
        requestItems: null,
        expandedUpdates: {},
        expandedRequests: {},
        selectFilterOrderStatuses: ['due','processing','sent','delivered','returning to sender','re-sent','received return','problem'],
        pageParams: {
            pageOptions: {page:1, sortBy:[], sortDesc:[], itemsPerPage: 30},
            search: {val: ""},
            filters: {
                status: { val: null, type: 'single' },
                date_start: { val: null, type: 'single' },
                date_end: { val: null, type: 'single' },
            }
        },
    }),
    methods: {
        async getPage(params = {}) {
            await this.getPageHandler({
                waitName: 'fulfilment.orders',
                action: 'fetchWarehouseOrders', // vuex action
                pageParams: this.pageParams,
                isInit: params.init !== 'undefined' ? params.init : false, // parse from url query params
                pushRoute: params.pushRoute !== 'undefined' ? params.pushRoute : true, // push pagination params and search q to route
                resetPagination: params.resetPagination !== 'undefined' ? params.resetPagination : false, // new search input -> need to reset page & sorting
                routeParams: params.routeParams !== 'undefined' ? params.routeParams : false, // extra params
                noWait: params.noWait !== 'undefined' ? params.noWait : false // extra params
            });
        },
        async sortBy(field) {
            let copy = JSON.parse(JSON.stringify(this.pageParams.pageOptions)); // VUE reactivity hack https://github.com/vuejs/vue/issues/2164#issuecomment-377517724
            if (copy.sortBy[0] === field) {
                if (copy.sortDesc[0] === false) {
                    copy.sortBy = [];
                    copy.sortDesc = [];
                } else {
                    copy.sortDesc = [false];
                }
            } else {
                copy.sortBy = [field];
                copy.sortDesc = [true];
            }
            this.pageParams.pageOptions = copy;
            console.log(this.pageParams.pageOptions.sortBy);
            console.log(this.pageParams.pageOptions.sortDesc);
            await this.getPage({resetPagination: true});
        },
        sortClass(field, sortBy, sortDesc) { // pageOptions param just to be reactive
            if (this.pageParams.pageOptions.sortBy && this.pageParams.pageOptions.sortBy[0] === field) {
                return {'sort': true, 'sort-up': !this.pageParams.pageOptions.sortDesc[0], 'sort-down': this.pageParams.pageOptions.sortDesc[0]};
            }
            return {};
        },
        async setFilter(param = null, val = null) {
            if (param) this.pageParams.filters[param].val = val;
            await this.getPage({resetPagination: true});
        },
        selectRow(item) {
            if (item.selected === 'undefined') item.selected = true;
            else item.selected = !item.selected;
        },
        async selectAll() {
            let unloadedItems = this.index.meta.total - this.index.data.length;
            if (unloadedItems > 1) {
                this.pageParams.pageOptions.itemsPerPage = this.index.meta.total;
                await this.getPage({
                    resetPagination: true
                });
            }
            for (let i in this.index.data) this.index.data[i].selected = true;
        },
        async loadMore() {
            this.lazyLoading = true;
            this.pageParams.pageOptions.page = this.index.meta.current_page+1;
            
            await this.getPage({pushRoute: false, noWait: true, routeParams: {appendResults:true}});
            this.lazyLoading = false;
        },
        handleScroll() {
           if (this.index.meta.current_page < this.index.meta.last_page && isInViewport(this.$refs.loadMore,0) && !this.lazyLoading) {
               this.loadMore();
           }
        },
        openWarehouseRequestModal(item = null) {
            if (item) this.requestItems = [item];
            else if (this.selectedOrdersCount)  this.requestItems = this.selectedOrders;
            else return;
            this.modals.whRequestModal = true;
        },
        async cancelOrders() {
            if (this.selectedOrders && confirm('Do you really want to delete selected orders? This can not be undone. Note: only DUE orders that has not been processed yet can and will be deleted.')) {
                let response = await this.dispatchWaitAndNotify('deleteWarehouseOrders', {delete: this.selectedOrders.map(a => a.id)});
                if (response.result === 'success') {
                    this.getPage();
                }
            }
        },
        openImportWHOrdersModal() {
            this.modals.importWHOrdersModal = true;
        },
        statusName(status) {
            if (status == 'CANCELLED/BLOCKED') return 'Cancelled';
            else return status.replace(
                /\w\S*/g,
                function(txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                }
            );
        },
        tooltip(line) {
            return {
                content: line.item_name + ' (' + line.quantity +'x)',
                delay: { show: 100, hide: 100 },
            }
        },
        toggleUpdates(id) {
            this.$set(this.expandedUpdates, id, this.expandedUpdates[id] === undefined ? true : !this.expandedUpdates[id])
        },
        toggleRequests(id) {
            this.$set(this.expandedRequests, id, this.expandedRequests[id] === undefined ? true : !this.expandedRequests[id])
        },
        getStatusCount(status) {
            if (!this.index.meta.statuses) return 0;
            let existingStatus = this.index.meta.statuses.find(el => { return el.status === status.toUpperCase(); });
            return existingStatus?existingStatus.total:0;
        }
        
    },
    mounted() {
        //this.pageParams.pageOptions.itemsPerPage = this.itemsPerPageCookie(this.$options.name);
        this.getPage({init:true});
        this.handleDebouncedScroll = debounce(this.handleScroll, 10);
        window.addEventListener('wheel', this.handleDebouncedScroll);
    },
    computed: {
        moment() {
            return moment
        },
        maxDate() {
            return new Date().toISOString().split("T")[0];
        },
        index() {
            return this.$store.state.warehouse.orders;
        },
        modals() {
            return this.$store.state.modals;
        },
        allOrdersCount() {
            const pluck = (arr, key) => arr.map(i => i[key]);
            if (this.index.meta.statuses) return pluck(this.index.meta.statuses, 'total').reduce((partialSum, a) => partialSum + a, 0);
            else return this.index.meta.total;
        },
        selectedOrders() {
            return this.index.data.filter(i => i.selected === true);
        },
        selectedOrdersCount() {
            const pluck = (arr, key) => arr.map(i => i[key]);
            if (this.index.data) return pluck(this.index.data, 'selected').reduce((partialSum, a) => partialSum + (a===true?1:0), 0);
            else return 0;
        },
        showFeesColumns() {
            if (this.$store.state.team?.detail?.slug==='ADHD') return true;
            if (this.$store.state.team?.detail?.slug==='dev-test') return true;
            return false;
        }
    },
    beforeDestroy() {
        window.removeEventListener('wheel', this.handleDebouncedScroll);
    },
}
</script>

<style scoped>
#list-of-warehouse-orders .package-content {
    width: 160px;
}

#list-of-warehouse-orders .package-content .package-item {
    width: 48px;
    height: 48px;
    float: left;
    margin-right: 5px;
    border-radius: 5px;
    background-color: #f5f5f5;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.fulfilment-action-button {
    white-space: nowrap;
    margin-top: 23px;
    height: 31px;
    line-height: 16px;
    margin-right: 10px;
}

.status-update {
    display: flex;
    justify-content: space-between;
}

.status-update-date {
    font-size: 10px; 
    margin-top: -5px; 
    display: block;
}

.status-update-extras {
    border-radius: 100px;
    font-size: 13px !important;
    line-height: 30px;
    height: 30px;
    padding: 0 10px !important;
    margin-top: 8px;
}

.status-update.hidden {
    display: none;
}

</style>